/**
 * Workflow graph island entry point.
 * Bundled separately as workflow-graph.js by build.mjs.
 */
import { mountWorkflowGraph } from "./workflow-graph.js";

// Auto-mount when the DOM is ready
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", mountWorkflowGraph);
} else {
  mountWorkflowGraph();
}
